import { ROUTES } from '../../pages/Home/const';

export const initialOption = { title: 'All', value: 'all' };

export const OPTIONS = [
  { title: 'Vacation', value: 'VAC' },
  { title: 'Administrative Leave', value: 'AL' },
  { title: 'Funeral Leave', value: 'BRV' },
  { title: 'Union Business', value: 'UNION' },
  { title: 'Department Business', value: 'DEPT' },
  { title: 'Sick (Self)', value: 'SICK_SELF' },
  { title: 'Sick (Family)', value: 'SICK_FAM' },
  { title: 'Leave with Pay', value: 'LWP' },
  { title: 'Leave without Pay', value: 'LWOP' },
  { title: 'Military Leave', value: 'MILITARY' },
  { title: 'Light Duty', value: 'LIGHT' },
  { title: 'Fill-in', value: 'SWAP' },
  { title: 'Injured', value: 'OJI' },
  { title: 'Reassignment', value: 'REASSIGN' },
  { title: 'Open Position', value: 'OPEN' },
  { title: 'Emergency Fill', value: 'Emergency' },
];

export const GROUPBY = [
  { title: 'Employee', value: 'Emp' },
  { title: 'Date', value: 'Date' },
];

export const GROUPBY_ACCRUAL = [
  { title: 'Employee', value: 'Emp' },
  { title: 'Accrual', value: 'Acc' },
];

export const REPORTS_INFO = {
  OVERTIME: {
    title: 'Overtime Report',
    description: 'Overtime hours by employee or date range, with pay code and reason filters.',
    id: 'overtime',
    link: ROUTES.REPORTS.OVERTIME_REPORT,
  },
  CALLBACK: {
    title: 'Callback Report',
    description: 'Callback fill activity, response times, and fill-time charts.',
    id: 'callback',
    link: ROUTES.REPORTS.CALLBACK_REPORT,
  },
  PTO: {
    title: 'PTO Report',
    description: 'PTO usage by employee, date range, and reason code.',
    id: 'pto',
    link: ROUTES.REPORTS.PTO_REPORT,
  },
  PAYROLL: {
    title: 'Payroll Report',
    description: 'Full payroll detail by employee and date range, including regular, overtime, and custom hours.',
    id: 'payroll',
    link: ROUTES.REPORTS.PAYROLL_REPORT,
  },
  PAYROLL_SUMMARY: {
    title: 'Payroll Summary Report',
    description: 'Summarized payroll totals by employee for a selected period.',
    id: 'payroll_summary',
    link: ROUTES.REPORTS.PAYROLL_SUMMARY_REPORT,
  },
  OVERTIME_LIST_MASTER: {
    title: 'Overtime List Master Report',
    description: 'Master list of all overtime list entries and sign-up activity.',
    id: 'overtime_list_master',
    link: ROUTES.REPORTS.OVERTIME_MASTER_REPORT,
  },
  MUNIS: {
    title: 'Munis Export Report',
    description: 'Payroll data formatted for Munis payroll system export.',
    id: 'munis',
    link: ROUTES.REPORTS.MUNIS_REPORT,
  },
  WEEKLY_PAYROLL: {
    title: 'Complete Weekly Payroll Report',
    description: 'Weekly overtime and hours summary across all employees.',
    id: 'weekly_payroll',
    link: ROUTES.REPORTS.WEEKLY_PAYROLL_REPORT,
  },
  SHIFT_SWAPS: {
    title: 'Shift Swaps Report',
    description: 'Shift swap and fill-in history by employee and date range.',
    id: 'swaps',
    link: ROUTES.REPORTS.SWAP_REPORT,
  },
  ADJUST_HOURS: {
    title: 'Adjust Hour Report',
    description: 'Manual hour adjustments by employee for a selected period.',
    id: 'Adjust_Hours',
    link: ROUTES.REPORTS.ADJUST_HOURS_REPORT,
  },
  AVAILABILITY_DETAILT: {
    // Note: 'DETAILT' is a typo in the original codebase — left as-is for consistency
    title: 'Availability Detail Report',
    description: 'Detailed employee availability by shift and assignment.',
    id: 'availability_detail',
    link: ROUTES.REPORTS.AVAILABILITY_DETAIL_REPORT,
  },
  AVAILABILITY_SUMMARY: {
    title: 'Availability Summary Report',
    description: 'Summarized availability counts by shift and date range.',
    id: 'availability_summary',
    link: ROUTES.REPORTS.AVAILABILITY_SUMMARY_REPORT,
  },
  MILTON: {
    title: 'Milton Report',
    description: 'Combined view of PTO, Overtime, Out of Grade, and Town/Private details for Milton FD.',
    id: 'custom',
    link: ROUTES.REPORTS.MILTON_REPORT,
    departmentSpecific: true,
  },
  HOLIDAY: {
    title: 'Holiday Time Report',
    description: 'Holiday time usage by employee and date range.',
    id: 'holiday',
    link: ROUTES.REPORTS.HOLIDAY_REPORT,
  },
  PTO_BALANCES: {
    title: 'PTO Balances Report',
    description: 'Current PTO balance per employee.',
    id: 'pto_balances',
    link: ROUTES.REPORTS.PTO_BALANCES,
  },
  WOBURN_PAYBACK: {
    title: 'Woburn Payback Report',
    description: 'Woburn-specific payback and detail tracking.',
    id: 'custom_payback',
    link: ROUTES.REPORTS.WOBURN_PAYBACK_REPORT,
    departmentSpecific: true,
  },
  WOBURN_OVERTIME: {
    title: 'Woburn Overtime Report',
    description: 'Woburn-specific overtime detail report.',
    id: 'custom_ot',
    link: ROUTES.REPORTS.WOBURN_OVERTIME_REPORT,
    departmentSpecific: true,
  },
  WOBURN_REASSIGNMENT: {
    title: 'Woburn Reassignment Report',
    description: 'Reassignment and acting-up tracking for Woburn FD.',
    id: 'custom_acting',
    link: ROUTES.REPORTS.WOBURN_REASSIGNMENT_REPORT,
    departmentSpecific: true,
  },
  WOBURN_PTO: {
    title: 'Woburn PTO Report',
    description: 'Woburn-specific PTO detail report.',
    id: 'custom_pto',
    link: ROUTES.REPORTS.WOBURN_PTO_REPORT,
    departmentSpecific: true,
  },
  WOBURN_MUNIS_PTO: {
    title: 'Woburn Munis PTO Report',
    description: 'Woburn PTO data formatted for Munis export.',
    id: 'custom_pto_munis',
    link: ROUTES.REPORTS.WOBURN_MUNIS_PTO_REPORT,
    departmentSpecific: true,
  },
  WOBURN_MUNIS_OVERTIME: {
    title: 'Woburn Munis Overtime Report',
    description: 'Woburn overtime data formatted for Munis export.',
    id: 'custom_ot_munis',
    link: ROUTES.REPORTS.WOBURN_MUNIS_OVERTIME_REPORT,
    departmentSpecific: true,
  },
  ACCRUAL_BALANCE: {
    title: 'Accrual Balance Report',
    description: 'Accrual balances by employee for a selected period.',
    id: 'accrual_balance',
    link: ROUTES.REPORTS.ACCRUAL_BALANCE,
  },
  HARPERS: {
    title: 'Harpers Report',
    description: "Employee CSV export for Harper's payroll integration.",
    id: 'harpers',
    link: '/firehouse/reports/harpers',
    departmentSpecific: true,
  },
  OUT_OF_GRADE: {
    title: 'Out of Grade Summary Report',
    description: 'Summary of employees working out of their assigned grade.',
    id: 'out_of_grade',
    link: '/firehouse/reports/out-of-grade-report',
  },
  EMPLOYEE_WORK_HOURS: {
    title: 'Employee Work Hours Report',
    description: 'Total work hours per employee for a selected date range.',
    id: 'employee_work_hours',
    link: '/firehouse/reports/employee-work-hours-report',
  },
  VOLUNTEER: {
    title: 'Volunteer Report',
    description: 'Volunteer activity duration and summary.',
    id: 'volunteer',
    link: '/firehouse/volunteer-report',
  },
  VOLUNTEER_OPEN_SHIFT: {
    title: 'Volunteer Open Shift Report',
    description: 'Open volunteer shifts by position, shift, and date range.',
    id: 'volunteer_open_shift',
    link: '/firehouse/volunteer-open-shift',
  },
  VOLUNTEER_MEMBER_HOURS: {
    title: 'Volunteer Member Hours Report',
    description: 'Total hours and shifts per volunteer member for a selected date range.',
    id: 'volunteer_member_hours',
    link: '/firehouse/volunteer-member-hours',
  },
  EMPLOYEE_HOURS_MONITOR: {
    title: 'Employee Hours Monitor',
    description: 'History of overtime list hour additions and reverts by employee.',
    id: 'employee_hours_monitor',
    link: '/firehouse/employee-hours-monitor',
    flagKey: 'V3_EMP_HOURS_MONITOR',
  },
  SHIFT_ALLOCATION: {
    title: 'Shift Allocation Report',
    description: 'Shift allocation breakdown by employee and date range.',
    id: 'shift_allocation',
    link: '/firehouse/reports/shift-allocation',
  },
  CHARLTON: {
    title: 'Charlton Report',
    description: 'Charlton-specific holiday time detail report.',
    id: 'custom_charlton',
    link: '/firehouse/reports/charlton',
    departmentSpecific: true,
  },
};

// Dev version - includes PTO_BALANCES
// export const ALWAYS_PRESENT_REPORTS_MAP = [
//   REPORTS_INFO.HOLIDAY,
//   REPORTS_INFO.PTO_BALANCES,
//   REPORTS_INFO.ACCRUAL_BALANCE,
// ];

// Prod version — PTO_BALANCES intentionally excluded until re-enabled
export const ALWAYS_PRESENT_REPORTS_MAP = [
  REPORTS_INFO.HOLIDAY,
  REPORTS_INFO.ACCRUAL_BALANCE,
];

/**
 * REPORT_CATEGORIES defines the landing page layout.
 * Each category has a label and an ordered list of REPORTS_INFO entries.
 * The landing page uses availableReportsIds to determine available vs. greyed-out state.
 */
export const REPORT_CATEGORIES = [
  {
    id: 'scheduling_overtime',
    label: 'Scheduling & Overtime',
    reports: [
      REPORTS_INFO.OVERTIME,
      REPORTS_INFO.OVERTIME_LIST_MASTER,
      REPORTS_INFO.WEEKLY_PAYROLL,
      REPORTS_INFO.CALLBACK,
      REPORTS_INFO.SHIFT_SWAPS,
      REPORTS_INFO.OUT_OF_GRADE,
      REPORTS_INFO.ADJUST_HOURS,
      REPORTS_INFO.AVAILABILITY_DETAILT,
      REPORTS_INFO.AVAILABILITY_SUMMARY,
      REPORTS_INFO.WOBURN_OVERTIME,
      REPORTS_INFO.WOBURN_MUNIS_OVERTIME,
    ],
  },
  {
    id: 'payroll_exports',
    label: 'Payroll & Exports',
    reports: [
      REPORTS_INFO.PAYROLL,
      REPORTS_INFO.PAYROLL_SUMMARY,
      REPORTS_INFO.MUNIS,
      REPORTS_INFO.HARPERS,
      REPORTS_INFO.WOBURN_PAYBACK,
      REPORTS_INFO.WOBURN_MUNIS_PTO,
      REPORTS_INFO.SHIFT_ALLOCATION,
    ],
  },
  {
    id: 'pto',
    label: 'PTO',
    reports: [
      REPORTS_INFO.PTO,
      REPORTS_INFO.PTO_BALANCES,
      REPORTS_INFO.ACCRUAL_BALANCE,
      REPORTS_INFO.EMPLOYEE_WORK_HOURS,
      REPORTS_INFO.WOBURN_PTO,
      REPORTS_INFO.WOBURN_REASSIGNMENT,
      REPORTS_INFO.HOLIDAY,
      REPORTS_INFO.CHARLTON,
    ],
  },
  {
    // Label is set dynamically in Reports.jsx using the department name from AuthContext
    // This category is hidden entirely if the department has no available reports in it
    id: 'department_custom',
    label: null,
    subtitle: 'Custom Reports',
    hideIfNoneAvailable: true,
    reports: [
      REPORTS_INFO.MILTON,
      REPORTS_INFO.VOLUNTEER,
      REPORTS_INFO.VOLUNTEER_OPEN_SHIFT,
      REPORTS_INFO.EMPLOYEE_HOURS_MONITOR,
    ],
  },
];
